import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { EmailLineContainer } from "../atoms/EmailLineContainer";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { TextField } from "@mui/material";

export const ContactLine = ({
  to,
  cc,
  bcc,
  handleOpenTo,
  handleOpenCc,
  handleOpenBcc,
  value,
}) => {
  return (
    <EmailLineContainer
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <TextField
        value={value}
        size="small"
        disabled
        variant="standard"
        sx={{
          width: "100%",
          "& .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
            borderBottom: 0,
          },
          "& .MuiInput-root::before": {
            borderBottom: 0,
          },
          "& .MuiInput-root::after": {
            borderBottom: 0,
          },
        }}
      />

      <Box sx={{ display: "flex" }}>
        <Button
          disableRipple
          sx={{
            p: 0,
            minWidth: 0,
            color: to ? "red" : null,
            textTransform: "capitalize",
          }}
          onClick={handleOpenTo}
        >
          To
        </Button>

        <Button
          disableRipple
          sx={{
            p: 0,
            minWidth: 0,
            ml: "8px",
            color: cc ? "red" : null,
            textTransform: "capitalize",
          }}
          onClick={handleOpenCc}
        >
          Cc
        </Button>

        <Button
          disableRipple
          sx={{
            p: 0,
            minWidth: 0,
            ml: "8px",
            color: bcc ? "red" : null,
            textTransform: "capitalize",
          }}
          onClick={handleOpenBcc}
        >
          Bcc
        </Button>
      </Box>
    </EmailLineContainer>
  );
};
